function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "s",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#29AAE2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#46C1F6"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "url(#s)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12.322 3.81a4.762 4.762 0 0 1 3.762 3.761M12.322 0a8.571 8.571 0 0 1 7.571 7.562m-.952 7.6v2.857a1.905 1.905 0 0 1-2.076 1.905A18.848 18.848 0 0 1 8.645 17a18.571 18.571 0 0 1-5.713-5.714A18.848 18.848 0 0 1 .008 3.029 1.905 1.905 0 0 1 1.903.952H4.76A1.905 1.905 0 0 1 6.665 2.59c.12.915.344 1.813.667 2.677.261.696.094 1.48-.429 2.01l-1.21 1.209a15.238 15.238 0 0 0 5.715 5.714l1.21-1.21a1.905 1.905 0 0 1 2.009-.428c.864.322 1.762.546 2.676.667a1.905 1.905 0 0 1 1.638 1.933z",
  transform: "translate(1.112 1)"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.d1cdf0e7.svg";
export { ForwardRef as ReactComponent };